import { render } from "./SitePlanTabsComponent.vue?vue&type=template&id=3ca605f6"
import script from "./SitePlanTabsComponent.vue?vue&type=script&lang=js"
export * from "./SitePlanTabsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__